import * as Actions from '../actions/actions';
import { sendRequest } from '../../../lib-alme-request/src/lib-alme-request';

export default class GetNotifications {
    constructor(settings) {
        this._settings = settings;
    }

    initialize(store) {
        this._store = store;
        this._pollTimeoutID = 0;
    }

    getNotifications() {
       try {
          if (this.isActiveSession()) {
               const input = {
                   messageType: this._settings.messageConstants.getNotificationRequest,
                   messageSource: this._settings.notificationsApi.extensibleMessageSource,
                };
               sendRequest(input);
          } else {
             this.startPolling();
          }
       } catch (e) {
          console.log(`Error while retrieving Alme notifications: ${e}`);
       }
    }

    isActiveSession() {
        let history = this._store.getState()[this._settings.stateLocations.History.Base][this._settings.stateLocations.History.Messages] || [];
        return history.length > 0;
    }

    isPolling() {
       return  !!this._pollTimeoutID;
    }

    startPolling() {
       if (!this.isPolling()) {
          this._pollTimeoutID = setInterval(() => { this.getNotifications(); }, this._settings.notificationsApi.pollIntervalMS);
          this.setPollingStatus(true);
       }
    }

    stopPolling() {
       clearInterval(this._pollTimeoutID);
       this._pollTimeoutID = 0;
       this.setPollingStatus(false);
    }

    setPollingStatus(isPolling) {
      this._store.dispatch(Actions.updatePollingStatus({
         stateLocation: this._settings.stateLocations.AlmeNotifications.pollingActive,
         isPolling
      }));
   }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/alme-notificationsapi/src/handlers/get-notifications.js